export const OperacionNotaEstructuradaFields = {
  CodPais: 'codPais',
  NombrePais: 'nombrePais',
  CodEstado: 'codOperacionNotaEstructuradaEstado',
  DescEstado: 'descOperacionNotaEstructuradaEstado',
  CodSectorComercial: 'codSectorComercial',
  NombreSectorComercial: 'nombreSectorComercial',
  RazonSocial: 'razonSocial',
  NroCuenta: 'nroCuenta',
  CodMoneda: 'codMoneda',
  DescMoneda: 'descMoneda',
  DescMonedaSimbolo: 'descMonedaSimbolo',
  FechaAprobacion: 'fechaAprobacion',
  FechaVencimiento: 'fechaVencimiento',
  FechaAlta: 'fechaAlta',
  IdUsuarioAlta: 'idUsuarioAlta',
  BitEnvio: 'enviar',
  PermiteEditar: 'permiteEditarOperacion',
  PermiteEliminar: 'permiteEliminarOperacion',
  NombreUsuarioAlta: 'nombreUsuarioAlta',
  ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
  MailUsuarioAlta: 'mailUsuarioAlta',
  Cuentas: 'cuentas'
} as const

export const OperacionNotaEstructuradaCuentaFields = {
  NroCuenta: 'nroCuenta',
  RazonSocial: 'razonSocial',
  CodMoneda: 'codMoneda',
  DescMoneda: 'descMoneda',
  SimboloMoneda: 'simboloMoneda',
  Sector: 'descOperacionNotaEstructuradaCuentaDetalleSeccion',
  Detalles: 'detalles',
  Importe: 'importe',
  ImporteConcertacion: 'importe_Concertacion',
  ImporteDPV: 'importe_DPV',
  ImporteFOP: 'importe_FOP',
  PermiteModificar: 'permiteModificar',
  Estilo: 'estilo',
} as const

export const OperacionNotaEstructuradaDetalleFields = {
  CodSeccion: 'codSeccion',
  DescSeccion: 'descSeccion',
  LimiteConcertacion: 'limiteConcertacion',
  LimiteDVP: 'limiteDVP',
  LimiteFOP: 'limiteFOP',
  PermiteModificar: 'permiteModificar',
} as const

export enum OperacionNotaEstructuradaLimiteFields {
  LimiteImporte = 'limiteImporte'
}